// These icons were taken (with color modification) from here: ckeditor5-table/theme/icons
import tableColumn from './table-column.svg';
import tableRow from './table-row.svg';
import tableMergeCells from './table-merge-cell.svg';

const icons = {
    tableColumn,
    tableRow,
    tableMergeCells
};
export default icons;
